"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
}, _react.default.createElement("path", {
  fill: "#666666",
  d: "M34.86,21.96 C34.94,21.32 35,20.68 35,20 C35,19.32 34.94,18.68 34.86,18.04 L39.08,14.74 C39.46,14.44 39.56,13.9 39.32,13.46 L35.32,6.54 C35.08,6.1 34.54,5.94 34.1,6.1 L29.12,8.1 C28.08,7.3 26.96,6.64 25.74,6.14 L24.98,0.84 C24.92,0.36 24.5,0 24,0 L16,0 C15.5,0 15.08,0.36 15.02,0.84 L14.26,6.14 C13.04,6.64 11.92,7.32 10.88,8.1 L5.9,6.1 C5.44,5.92 4.92,6.1 4.68,6.54 L0.68,13.46 C0.42,13.9 0.54,14.44 0.92,14.74 L5.14,18.04 C5.06,18.68 5,19.34 5,20 C5,20.66 5.06,21.32 5.14,21.96 L0.92,25.26 C0.54,25.56 0.44,26.1 0.68,26.54 L4.68,33.46 C4.92,33.9 5.46,34.06 5.9,33.9 L10.88,31.9 C11.92,32.7 13.04,33.36 14.26,33.86 L15.02,39.16 C15.08,39.64 15.5,40 16,40 L24,40 C24.5,40 24.92,39.64 24.98,39.16 L25.74,33.86 C26.96,33.36 28.08,32.68 29.12,31.9 L34.1,33.9 C34.56,34.08 35.08,33.9 35.32,33.46 L39.32,26.54 C39.56,26.1 39.46,25.56 39.08,25.26 L34.86,21.96 Z M20,27 C16.14,27 13,23.86 13,20 C13,16.14 16.14,13 20,13 C23.86,13 27,16.14 27,20 C27,23.86 23.86,27 20,27 Z",
  transform: "translate(12 12)"
}));

exports.default = _default;
module.exports = exports.default;